import { apiGet, apiSend, USE_MOCK_API } from './httpClient'

export interface CalendarEvent {
  event_id: string
  summary: string
  description: string | null
  location: string | null
  start: string | null
  end: string | null
  is_all_day: boolean
}

export interface ExportedEvent {
  point_id: string
  calendar_event_id: string | null
  success: boolean
}

const MOCK_EVENTS: CalendarEvent[] = [
  {
    event_id: 'cal_demo_001',
    summary: 'Flight TLV → FCO',
    description: 'Confirmation: ABC123',
    location: 'Ben Gurion Airport',
    start: '2026-08-10',
    end: '2026-08-10',
    is_all_day: false,
  },
  {
    event_id: 'cal_demo_002',
    summary: 'Hotel Colosseum Check-in',
    description: 'Booking #BK9876 — 5 nights',
    location: 'Hotel Colosseum, Rome',
    start: '2026-08-10',
    end: '2026-08-15',
    is_all_day: true,
  },
  {
    event_id: 'cal_demo_003',
    summary: 'Vatican Museums Tour',
    description: 'Group tour — confirmation EXP777',
    location: 'Vatican City',
    start: '2026-08-12',
    end: '2026-08-12',
    is_all_day: false,
  },
]

export async function listCalendarEvents(tripId: string): Promise<CalendarEvent[]> {
  if (USE_MOCK_API) return MOCK_EVENTS
  return apiGet<CalendarEvent[]>(`/trips/${tripId}/calendar/events`)
}

export async function importCalendarEvents(
  tripId: string,
  eventIds: string[],
): Promise<{ id: string; title: string; type: string }[]> {
  if (USE_MOCK_API) {
    return eventIds.map((id) => ({
      id: `point_${id}`,
      title: MOCK_EVENTS.find((e) => e.event_id === id)?.summary ?? id,
      type: 'free',
    }))
  }
  return apiSend(`POST`, `/trips/${tripId}/calendar/import`, { event_ids: eventIds })
}

export async function exportPointsToCalendar(
  tripId: string,
  pointIds: string[],
): Promise<ExportedEvent[]> {
  if (USE_MOCK_API) {
    return pointIds.map((pid) => ({ point_id: pid, calendar_event_id: `gcal_${pid}`, success: true }))
  }
  return apiSend(`POST`, `/trips/${tripId}/calendar/export`, { point_ids: pointIds })
}
